<template>
  <v-container fluid id="toolRun">
    <v-row wrap justify="center">
      <v-col sm="9">
        <h1 class="headline">Tool Run Builder</h1>
      </v-col>
      <v-spacer></v-spacer>
      <v-col align="right">
        <v-dialog v-model="dialog" width="500">
          <template v-slot:activator="{ on }">
            <v-btn small color="primary" v-on="on">
              <v-icon left small>email</v-icon>Review
            </v-btn>
          </template>

          <v-card>
            <v-card-title class="headline" primary-title
              >Final Review</v-card-title
            >
            <!-- <v-card-text>
              <p v-if="jobSite">{{ jobSite.address }}</p>
              <v-simple-table class="my-4" dense>
                <template v-slot:default>
                  <tbody>
                    <tr
                      v-for="t in toolsOnSite.filter((t) => t.pickupQty > 0)"
                      :key="t.id"
                    >
                      <td class="pl-0">{{ t.title }}</td>
                      <td>{{ t.pickupQty }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <div v-if="notes">
                Note for the yard:
                <br />
                <strong>{{ notes }}</strong>
              </div>
            </v-card-text> -->
            <v-card-actions class="pa-2">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialog = false" class="px-4"
                >Cancel</v-btn
              >
              <v-btn color="primary" @click="placePickupRequest" class="px-4"
                >Submit</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row wrap justify="center">
      <v-col cols="6">
        <v-card>
          <v-tabs active-class="active-tab" v-model="tab">
            <v-tab @click="tab = 'toolOrders'">Tool Orders</v-tab>
            <v-tab @click="tab = 'pickups'">Pickups</v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-tabs-items v-model="tab">
            <v-tab-item key="toolOrders">
              <div class="px-4 pt-3 pb-0">
                <v-text-field
                  type="search"
                  hide-details
                  label="Filter by Address"
                  prepend-inner-icon="search"
                  color="primary"
                  dense
                  v-model="search"
                  clearable
                  outlined
                  v-if="!loading"
                ></v-text-field>
              </div>
              <div v-if="loading" class="pa-4">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  class="mr-4"
                ></v-progress-circular>
                <span class="caption">Loading...</span>
              </div>
              <v-card
                class="mb-2 elevation-0"
                dense
                v-else
                v-for="order in recentOrders"
                :key="order.orderNumber"
                :class="{
                  'd-none': toolRun.some(
                    (tr) => order.orderNumber == tr.orderNumber
                  ),
                }"
              >
                <v-card-text class="pb-0 pt-1">
                  <div class="mb-2">
                    <v-container class="pa-0">
                      <v-row>
                        <v-col sm="8" class="py-0">
                          <strong class="ml-2 primary--text">{{
                            order.jobSite.street
                          }}</strong>
                          <br />
                          <span class="caption ml-2">
                            Order #{{ order.orderNumber }} by
                            {{ order.orderedBy.firstName }}
                            {{ order.orderedBy.lastName }} on
                            {{ order.orderDate.toDate() | moment("MMM Do") }}
                          </span>
                        </v-col>
                        <v-col sm="4" align="right" class="py-0">
                          <v-btn
                            color="primary elevation-0"
                            x-small
                            @click="addOrder(order)"
                          >
                            Add
                            <v-icon class="ml-1" x-small>chevron_right</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </div>
                  <v-simple-table dense id="sub-table">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <td alight="right">
                            <span class="caption grey--text">Fulfilled</span>
                          </td>
                          <td width="90%">
                            <span class="caption grey--text">Tool Name</span>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="tool in order.tools" :key="tool.id">
                          <td align="center">{{ fulfilledAmount(tool) }}</td>
                          <td>
                            {{ tool.title }}
                            <span
                              class="red--text"
                              v-if="tool.deliveredBy !== 'Alba Yard'"
                              >- delivery by {{ tool.deliveredBy }}</span
                            >
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <!-- PICKUPS -->
            <v-tab-item key="pickups">
              <v-card
                class="mb-2 elevation-0"
                dense
                v-for="order in pickups"
                :key="order.orderNumber"
                :class="{
                  'd-none': toolRun.some(
                    (tr) => order.orderNumber == tr.orderNumber
                  ),
                }"
              >
                <v-card-text>
                  <div class="mb-2">
                    <v-container class="pa-0">
                      <v-row>
                        <v-col sm="8" class="py-0">
                          <strong class="ml-2 primary--text">{{
                            order.jobSite.street
                          }}</strong>
                          <br />
                          <span class="caption ml-2">
                            Pickup #{{ order.orderNumber }} by
                            {{ order.orderedBy.firstName }}
                            {{ order.orderedBy.lastName }}
                          </span>
                        </v-col>
                        <v-col sm="4" align="right" class="py-0">
                          <v-btn
                            color="primary elevation-0"
                            x-small
                            @click="addOrder(order)"
                          >
                            Add
                            <v-icon class="ml-1" x-small>chevron_right</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </div>
                  <v-simple-table dense id="sub-table">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <td alight="right">
                            <span class="caption grey--text">Pickup</span>
                          </td>
                          <td width="90%">
                            <span class="caption grey--text">Tool Name</span>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="tool in order.tools" :key="tool.id">
                          <td align="center">{{ tool.pickupQty }}</td>
                          <td>{{ tool.title }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>

      <v-col cols="6">
        <v-card>
          <v-card
            class="mb-2 elevation-0"
            dense
            v-for="order in toolRun"
            :key="order.orderNumber"
          >
            <v-card-text class="mb-0 py-2 pb-3">
              <div class="mb-2">
                <v-container class="pa-0">
                  <v-row>
                    <v-col sm="8" class="py-0">
                      <strong class="primary--text">
                        {{ order.jobSite.street }}
                      </strong>
                      <span
                        class="font-weight-bold caption red--text mr-1"
                        v-if="order.pickupType"
                      >
                        <v-icon small color="red" class="mr-1">publish</v-icon
                        >PICKUP
                      </span>
                      <span
                        class="font-weight-bold caption blue--text mr-1"
                        v-else
                      >
                        <v-icon small color="blue" class="mr-1">get_app</v-icon
                        >DROPOFF
                      </span>
                    </v-col>
                    <v-col sm="4" align="right" class="py-0">
                      <v-btn
                        color="grey darken-1"
                        class="elevation-0"
                        dark
                        x-small
                        @click="removeOrder(order)"
                      >
                        <v-icon class="mr-1" x-small>chevron_left</v-icon>Remove
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="mb-0 pb-0">
                      <v-text-field
                        label="Time"
                        v-model="order.toolRunTime"
                        type="time"
                        style="font-size:12px;min-height:40px"
                        color="primary"
                        outlined
                        class="tool-run-time"
                      ></v-text-field>
                    </v-col>
                    <v-col class="mb-0 pb-0">
                      <v-select
                        label="Driver"
                        v-model="order.driver"
                        :items="[
                          'Myron Mercedes',
                          'Robert Sepulveda',
                          'Jesus Marcano',
                          'Calum Kerr',
                        ]"
                        type="time"
                        style="font-size:12px"
                        class
                        color="primary"
                        outlined
                        dense
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
              <v-simple-table dense id="sub-table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <td alight="right">
                        <span class="caption grey--text">
                          <span v-if="order.pickupType">Pickup</span>
                          <span v-else>Fulfilled</span>
                        </span>
                      </td>
                      <td width="90%">
                        <span class="caption grey--text">Tool Name</span>
                      </td>
                      <!-- <td style="width:200px">
                        <span class="caption grey--text">Requested</span>
                      </td>-->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="tool in order.tools" :key="tool.id">
                      <td align="center">
                        <span v-if="order.pickupType">{{
                          tool.pickupQty
                        }}</span>
                        <span v-else>{{ fulfilledAmount(tool) }}</span>
                      </td>
                      <td>
                        {{ tool.title }}
                        <span
                          class="red--text"
                          v-if="
                            tool.deliveredBy && tool.deliveredBy !== 'Alba Yard'
                          "
                          >- delivery by {{ tool.deliveredBy }}</span
                        >
                      </td>
                      <!-- <td>{{ tool.qty }}</td> -->
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import fb from "@/main";
import moment from "moment";
import { sumBy, sortBy } from "lodash";
export default {
  data() {
    return {
      tab: "toolOrders",
      dialog: false,
      loading: true,
      recentOrders: [],
      pickups: [],
      toolRun: [],
      search: "",
    };
  },
  async created() {
    const res = await fb.db
      .collection("toolOrders")
      .orderBy("orderDate", "desc")
      .where("fulfilled", "==", true)
      .limit(60)
      .get();
    let recentOrders = [];
    res.forEach((u) => {
      recentOrders.push({
        id: u.id,
        ...u.data(),
      });
    });

    let resPickups = await fb.db
      .collection("toolPickups")
      .where("status", "==", "open")
      .get();
    let pickups = [];
    resPickups.forEach((u) => {
      pickups.push({
        id: u.id,
        ...u.data(),
      });
    });
    // not adjustements
    recentOrders = recentOrders.filter(
      (ro) => ro.orderedBy.email !== "R.DiSabella@ALBADemo.com"
    );
    // not cancelled
    recentOrders = recentOrders.filter((ro) => !ro.cancelled);

    pickups = pickups.filter((pu) => pu.pickupType !== "First Time Adjustment");

    recentOrders = sortBy(recentOrders, [
      function(o) {
        return o.jobSite.id;
      },
    ]);

    recentOrders.forEach((ro) => {
      const day = moment(ro.requestDay.requestDate.toDate()).format("LLL");
    });

    this.recentOrders = recentOrders;
    this.pickups = pickups;
    this.loading = false;
  },
  computed: {
    filteredItems() {
      if (this.search == null) {
        this.search = "";
      }
      return this.recentOrders.filter((item) => {
        return (
          item.jobSite.address
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) > -1
        );
      });
    },
  },
  methods: {
    fulfilledAmount(tool) {
      if (!tool.fulfillments) tool.fulfillments = [];
      if (!tool.fulfillments.length) {
        return tool.qtyFulfilled || 0;
      } else {
        return sumBy(tool.fulfillments, "qty");
      }
    },
    addOrder(order) {
      this.toolRun.push({ ...order });
    },
    removeOrder(order) {
      this.toolRun = this.toolRun.filter(
        (tr) => order.orderNumber !== tr.orderNumber
      );
    },
    placePickupRequest(order) {
      console.log(order);
    },
  },
};
</script>

<style>
#toolRun .active-tab {
  background: whitesmoke;
}
#sub-table td,
#sub-table thead {
  background: #f7f7f7;
}
#toolRun .v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 42px !important;
}
#toolRun .v-text-field__details {
  display: none;
}
</style>
